export default __webpack_public_path__ + "static/media/2151895854.7eae2eca.jpg";